import React from 'react'
import {SavedCandidate} from '../Pages/SavedCandidates/SavedCandidates'

function Savedcandidates() {
  return (
    <>
        <SavedCandidate />
    </>
  )
}

export default Savedcandidates
